import React from "react";
import * as EmailValidator from "email-validator";

import {
  TextField,
  InputAdornment,
  CircularProgress,
  Button,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import { createUseStyles } from "react-jss";

import { ReactComponent as SubmitIcon } from "assets/icons/SubmitIcon.svg";
import styles from "assets/jss/material-dashboard-pro-react/components/utils/emailStyle.js";
import { atlanticColor } from "assets/jss/material-dashboard-pro-react";

import CustomAlert from "components/Alert/CustomAlert";
import { addEmailToContactForm } from "database/Firestore";

const useStyles = createUseStyles(styles);

/* ----------------------------------
   Styled TextField (replaces withStyles)
----------------------------------- */
const ValidationTextField = styled(TextField)(() => ({
  boxSizing: "border-box",
  borderRadius: "7px",
  width: "100%",
  maxWidth: "300px",
  height: "37px",

  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: `2px solid ${atlanticColor[0]}`,
    },
    "&.Mui-focused fieldset": {
      border: `2px solid ${atlanticColor[0]}`,
    },
    "&.Mui-error fieldset": {
      border: `2px solid ${atlanticColor[0]}`,
    },
  },
}));

export default function ContactForm(props) {
  const classes = useStyles();
  const { setMasterAlert } = props;

  const [email, setEmail] = React.useState("");
  const [emailError, setEmailError] = React.useState(null);
  const [emailHelperText, setEmailHelperText] = React.useState("");
  const [symbol, setSymbol] = React.useState(<SubmitIcon />);

  const handleEmail = (e) => {
    if (e.keyCode === 13) {
      sendEmail();
    }
  };

  const sendEmail = async () => {
    setSymbol(
      <CircularProgress className={classes.circularProgress} size={20} />
    );

    const validated = EmailValidator.validate(email);

    if (validated) {
      setEmailError(false);

      try {
        await addEmailToContactForm(email);

        setEmailHelperText("Email address added to contact list!");
        setMasterAlert(
          <CustomAlert
            title="Email received!"
            onConfirm={() => setMasterAlert(null)}
            onCancel={() => setMasterAlert(null)}
            confirmBtnText="Done"
            success
          />
        );
      } catch (error) {
        console.error(error);
      }
    } else {
      setEmailError(true);
      setEmailHelperText("Incorrect email");
    }

    setSymbol(<SubmitIcon />);
  };

  React.useEffect(() => {
    if (email === "") setEmailHelperText("");
  }, [email]);

  return (
    <ValidationTextField
      className={classes.textField}
      variant="outlined"
      placeholder="Email"
      error={emailError}
      helperText={emailHelperText}
      onKeyDown={handleEmail}
      onChange={(e) => setEmail(e.target.value)}
      InputProps={{
        classes: {
          root: classes.inputRoot,
        },
        endAdornment: (
          <InputAdornment position="end">
            <Button
              className={`${classes.atlantic} ${classes.submitBtn}`}
              onClick={sendEmail}
            >
              {symbol}
            </Button>
          </InputAdornment>
        ),
      }}
    />
  );
}
